import { useState, useEffect } from 'react';

export function useActiveSection(ids) {
  const [activeId, setActiveId] = useState(null);

  useEffect(() => {
    const validIds = (ids || []).filter(Boolean);
    if (validIds.length === 0) { setActiveId(null); return; }

    const elements = validIds.map(id => document.getElementById(id)).filter(Boolean);
    if (elements.length === 0) { setActiveId(null); return; }

    // Usa rootMargin per creare una banda ristretta di rilevamento vicino alla cima
    // del viewport (subito sotto l'header). In questo modo al massimo una sezione
    // può essere "attiva" contemporaneamente, indipendentemente da quanto sono vicine.
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            setActiveId(entry.target.id);
          } else {
            setActiveId(prev => prev === entry.target.id ? null : prev);
          }
        });
      },
      { rootMargin: '-100px 0px -60% 0px', threshold: 0 }
    );

    elements.forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, [(ids || []).filter(Boolean).join(',')]);

  return activeId;
}
